// Third party --------------
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'

// Components ---------------
import { Spinner } from 'core/components'
import variables from 'core/styles/variables'

// Rest ---------------------
import { useFormDisabled } from 'loan/components/actionCards/shared/DisabledContext'

// Styles -------------------
import { InnerContainer, Input, Label, OuterContainer } from './CheckboxStyles'

export const DisabledReason = styled.div`
  padding: 8px 0 0 32px;
  font-size: 14px;
  font-weight: 300;
  color: ${variables.colorBlack60};
`

const Checkbox = props => {
  const {
    checked,
    children,
    color,
    disabled,
    disabledReason,
    flexReverse,
    fontSize,
    label,
    loading,
    margin,
    onChange,
    onClick,
    padding,
    value
  } = props

  const isDisabled = useFormDisabled(disabled)

  return (
    <OuterContainer margin={margin}>
      <InnerContainer className='checkbox' flexReverse={flexReverse}>
        <>
          {loading ? (
            <Spinner />
          ) : (
            <Input
              checked={checked}
              disabled={isDisabled}
              id={value}
              name={value}
              onChange={onChange}
              onClick={onClick}
              type='checkbox'
              value={value}
            />
          )}
        </>
        <Label
          color={color}
          flexReverse={flexReverse}
          fontSize={fontSize}
          htmlFor={value}
          padding={padding}
        >
          {label}
        </Label>
        {disabled && disabledReason && (
          <DisabledReason>{disabledReason}</DisabledReason>
        )}
        {children}
      </InnerContainer>
    </OuterContainer>
  )
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string,
  flexReverse: PropTypes.bool,
  fontSize: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  margin: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  padding: PropTypes.string,
  value: PropTypes.string.isRequired
}

Checkbox.defaultProps = {
  margin: '0'
}

export default Checkbox
